import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of as observableOf } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { actionAndETagUpdate$ } from '®shared/container-structure/edit/queue';
import { getETagFromMetaObject } from '®shared/tarl-v3-jsonapi';

import { ReviewService } from '../review.service';

import {
  RequestReviewActionTypes,
  RequestReviewFailedAction,
  RequestReviewSendRequestAction,
  RequestReviewSucceededAction,
} from './request-review.actions';

@Injectable()
export class RequestReviewEffects {
  sendReviewRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RequestReviewActionTypes.REQUEST_REVIEW_SEND_REQUEST),
      switchMap((action: RequestReviewSendRequestAction) => {
        const { listId } = action.payload;
        return this.reviewService.createReview(listId).pipe(
          switchMap(({ entity, meta }) =>
            actionAndETagUpdate$(
              new RequestReviewSucceededAction({
                ...action.payload,
                review: entity,
              }),
              getETagFromMetaObject(meta),
            ),
          ),
          catchError(error =>
            observableOf(
              new RequestReviewFailedAction({
                ...action.payload,
                error,
              }),
            ),
          ),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private reviewService: ReviewService,
  ) {}
}
